module.exports = __webpack_public_path__ + "static/media/facture.a48ab6bb.png";